<template>
    <div>
        <app-no-data-message v-if="!tableData.length" />
        <app-data-table
            :fields="fields"
            :items="tableData"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template
                #status="{ item }"
                class="d-flex flex-column items-center justify-content-center"
            >
                {{ item.petition_status.name }}
                <span
                    style="font-size: 1.5rem"
                    :title="item.satisfaction_description"
                >
                    {{
                        !!item.satisfaction_value
                            ? ['😡', '😞', '🙂', '😍'][
                                  parseInt(item.satisfaction_value) - 1
                              ]
                            : ''
                    }}
                </span>
            </template>
            <template slot="type" slot-scope="{ item }">
                <b-badge :title="item.petition_type.name">{{
                    item.petition_type.name.substring(0, 1)
                }}</b-badge>
            </template>
            <template slot="description" slot-scope="{ item }">
                {{ item.description | elipsis(80) }}
            </template>

            <template slot="created_at" slot-scope="{ item }">
                {{ item.created_at | datetime }}
            </template>

            <template slot="due_date" slot-scope="{ item }">
                {{ item.due_date | datetime }}
            </template>

            <template slot="expiration_days" slot-scope="{ item }">
                <div v-if="moment().diff(moment(item.due_date), 'days') >= 0">
                    {{ moment().diff(moment(item.due_date), 'days') }}
                </div>
                <div v-else>0</div>
            </template>

            <template v-slot:lastPetitionAssignmentAssignationDate="{ item }">
                <span v-if="!!item.lastPetitionAssignment">
                    {{ item.lastPetitionAssignment.created_at | datetime }}
                </span>
            </template>

            <template v-slot:lastPetitionAssignmentAnswerDate="{ item }">
                <span v-if="!!item.lastPetitionAssignment">
                    {{ item.lastPetitionAssignment.answer_date | datetime }}
                </span>
            </template>

            <template v-slot:lastPetitionAssignmentUser="{ item }">
                <div>
                    <span
                        v-if="!!item.lastPetitionAssignment"
                        :class="{
                            'text-danger': !!item.user.deleted_at,
                        }"
                        >{{
                            item.lastPetitionAssignment?.user?.name ??
                            'Sin responsable'
                        }}</span
                    >
                    <span v-else>Sin Responsable</span>
                </div>
            </template>

            <template slot="files" slot-scope="{ item }">
                <div v-if="item.files.length">
                    <a
                        v-for="(file, i) in item.files"
                        :key="i"
                        :href="'/download/' + file.id"
                        target="_blank"
                        >{{ i + 1 }} - {{ file.name }}</a
                    >
                </div>
            </template>

            <template slot="approved_by_company_at" slot-scope="{ item }">
                {{ item.approved_by_company_at | datetime }}
            </template>

            <template slot="actions" slot-scope="{ item }">
                <b-button
                    variant="primary"
                    size="sm"
                    title="Ver PQR"
                    @click="seeMore(item)"
                    ><i class="fa fa-search-plus" aria-hidden="true"></i
                ></b-button>
                <b-button
                    variant="primary"
                    size="sm"
                    title="Agregar Comentario"
                    @click="startAddComment(item)"
                    ><i class="fa fa-pencil-square-o" aria-hidden="true"></i
                ></b-button>
                <b-button
                    v-if="
                        userCan('approve-client-petition') &&
                        !item.approved_by_client &&
                        item.approved_by_company
                    "
                    variant="primary"
                    size="sm"
                    title="Aprobar Respuesta"
                    @click="startApprove(item)"
                >
                    <i class="fa fa-check" aria-hidden="true"></i>
                </b-button>
                <b-button
                    v-if="
                        userCan('reject-client-petition') &&
                        !item.approved_by_client &&
                        item.approved_by_company
                    "
                    variant="danger"
                    size="sm"
                    title="Rechazar Respuesta"
                    @click="startRejectPetition(item)"
                >
                    <i class="fa fa-times" aria-hidden="true"></i>
                </b-button>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            fields,
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        seeMore: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
        startAddComment: {
            type: Function,
            required: true,
        },
        startRejectPetition: {
            type: Function,
            required: true,
        },
        startApprove: {
            type: Function,
            required: true,
        },
    },
    computed: {
        tableData() {
            if (!this.data || !this.data.data || !this.data.data.length)
                return []
            return this.data.data.map((item) => {
                let today = moment()
                let dueDate = moment(item.due_date)
                const classes = today.isSame(dueDate, 'day')
                    ? 'today'
                    : today.isAfter(dueDate) && !item.approved_by_client
                    ? 'overdue'
                    : ''
                const _rowDetails = true
                return { ...item, classes, _rowDetails }
            })
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}

const fields = [
    {
        key: 'id',
        label: 'ID',
    },
    {
        key: 'type',
        label: 'Tipo',
    },
    {
        key: 'status',
        label: 'Estado',
        orderBy: 'petition_statuses.name',
    },
    {
        key: 'client.name',
        label: 'Cliente',
    },
    {
        key: 'user.name',
        label: 'Usuario creador',
    },
    {
        key: 'description',
        label: 'Descripción',
    },
    {
        key: 'created_at',
        label: 'Fecha creación',
    },
    {
        key: 'due_date',
        label: 'Fecha vencimiento',
    },
    {
        key: 'expiration_days',
        label: 'días de vencimiento',
        orderBy: 'due_date',
    },
    {
        key: 'lastPetitionAssignmentAssignationDate',
        label: 'Fecha asignación responsable',
    },
    {
        key: 'lastPetitionAssignmentAnswerDate',
        label: 'Fecha respuesta responsable',
    },
    {
        key: 'lastPetitionAssignmentUser',
        label: 'Usuario asignado',
        orderBy: 'assigneeName',
    },
    {
        key: 'approved_by_company_at',
        label: 'Fecha aprobación compañía',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
